import Autocomplete from '../../autocomplete/vue-autocomplete.vue';
import AreaCheckbox from '../../areaCheckbox/';

const alert = require('vue-strap').alert;

export default {
  name: 'personal-details',
  props: [
    'onLogout',
    'access_token',
    'authUser',
    'type',
  ],
  mounted() {

  },
  components: { Autocomplete, AreaCheckbox, alert },
  data() {
    return {
      usersList: [],
      selectedUser: null,
      usersListOptions: [],
      mustDelete: false,
      // authUser: null,
      formData: {
        id: null,
        first_name: '',
        last_name: '',
        username: '',
        email: '',
        upn: '',
        passwordForm: '',
        confirmPassword: '',
        img: '',
        // picture: null,
        pictureBugFixer: null,
        company: null,
        role: ((this.type === 'admin') ? 'shift_leader' : 'basic'),
        areas: [],
      },
      userData: {},
      suggestArea: [],
      areas: [],
      areasChecked: [],
      areaFromList: false,
      roles: [
        {
          text: 'Shift leader',
          value: 'shift_leader',
        },
        {
          text: 'Manager',
          value: 'manager',
        },
      ],
      alertError: {
        text: 'Some required fields are not filled',
        title: 'Error!',
        visible: false,
      },
      alertSuccess: {
        text: 'User created, tab will be closed in 3 seconds',
        title: '',
        visible: false,
      },
      needFill: false,
    };
  },
  methods: {
    getUsersList() {
      let url = 'users/';
      if (this.$route.params.companyId) {
        url = `${url}?company=${this.$route.params.companyId}`;
      }
      return this.$http.get(url,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            // that.$set(that, 'moduleError', true);
            return null;
          }
          this.usersList = response.body.filter((user) => {
            return !user.is_deleted && user.id.toString() !== this.$route.params.userId;
          });
          this.usersListOptions = this.usersList.map((user) => {
            return {value: user.id, text: `${user.first_name} ${user.last_name}`};
          })
          .sort((a, b) => {
            if (a.text > b.text) return 1;
            if (a.text < b.text) return -1;
            return 0;
          });
          return response;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    readURL(input) {
      const self = this;
      if (input.files && input.files[0]) {
        this.formData.pictureBugFixer = input.files[0];
        const reader = new FileReader();
        reader.onload = (e) => {
          // $('#icon').attr('src', e.target.result);
          self.formData.img = e.target.result;
          self.imageOrientation(input, self);
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    handleFileChange(e) {
      // this.formData.img = e.target.files[0].name;
      e.preventDefault();
      if (e.target.files && e.target.files[0] && e.target.files[0].size > 5000000) {
        e.target.value = '';
        this.alertError.text = 'Maximum allowed file size is 5 MB.';
        this.alertError.visible = true;
        return;
      }
      this.readURL(e.target);
    },
    getWorkingAreas() {
      let url = 'areas/?is_system=false';
      if (this.$route.params.companyId) {
        url = `${url}&company=${this.$route.params.companyId}`;
      }
      return this.$http.get(url,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            return;
          }
          this.areas = response.body;
          // return response;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    processJSON(json) {
      return json.results;
    },
    getDataSearchArea(data, area) {
      for (let i = 0; i < this.areasChecked.length; i++) {
        if (this.areasChecked[i].id === area.area.id) {
          return;
        }
      }
      this.areasChecked.push(area.area);
    },
    getUserAreaPath(area) {
      const result = [];
      for (let i = 0; i < area.length; i++) {
        const res = this.getUserAreaPath(area[i].subareas);
        for (let j = 0; j < res.length; j++) {
          result.push({ name: `${area[i].name}/${res[j].name}`, area: res[j].area });
        }
        if (res.length === 0) {
          result.push({ name: area[i].name, area: area[i] });
        }
      }
      return result;
    },
    selectedAreaChanged(area) {
      console.log('areachanged', area[0].name);
    },
    updateSuggestArea() {
      this.suggestArea = [];
      const areaPaths = this.getUserAreaPath(this.areas);
      for (let i = 0; i < areaPaths.length; i++) {
        this.suggestArea.push(areaPaths[i]);
      }
    },
    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    onClickDelete() {
      this.$refs.confirm_delete.hide();
      if (this.formData.open_actions_count || this.formData.assigned_actions_count) {
        this.$refs.assign_to_user.show();
      } else {
        this.deleteUser(this.formData.id);
      }
    },
    deleteUser(id) {
      this.$http.put(`users/${id}/deactivate/`, { successor: this.selectedUser ? this.selectedUser : null },
        {
          method: 'PUT',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            return;
          }
          this.alertSuccess.text = 'User successfully deleted, tab will be closed in 3 seconds';
          this.alertSuccess.visible = true;
          this.needFill = false;
          setTimeout(() => {
            this.returnBack();
          }, 3000);
          // return response;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    submitUser() {
      const self = this;
      this.alertError.visible = false;
      this.alertError.text = 'Some required fields are not filled';
      if (this.formData.id) {
        this.alertSuccess.text = 'Saved successfully, tab will be closed in 3 seconds';
      }
      if (this.formData.email && !this.validateEmail(this.formData.email)) {
        this.alertError.text = 'Invalid Email';
        this.alertError.visible = true;
        this.needFill = true;
        return null;
      }
      if (!this.formData.username && !this.validateEmail(this.formData.email)) {
        this.alertError.text = 'Username or Email mandatory';
        this.alertError.visible = true;
        this.needFill = true;
        return null;
      }
      if (this.formData.id && (this.formData.passwordForm.length !== 0 &&
          (this.formData.passwordForm !== this.formData.confirmPassword))) {
        this.alertError.text = "Passwords don't match";
        this.alertError.visible = true;
        this.needFill = true;
        return null;
      }
      if (!this.formData.id && this.formData.passwordForm.length === 0) {
        this.alertError.text = 'Password mandatory';
        this.alertError.visible = true;
        this.needFill = true;
        return null;
      }
      if (!this.formData.id && (this.formData.passwordForm.length === 0 ||
          (this.formData.passwordForm !== this.formData.confirmPassword))) {
        this.alertError.text = "Passwords don't match";
        this.alertError.visible = true;
        this.needFill = true;
        return null;
      }
      if ((this.formData.passwordForm.length !== 0) &&
        (this.formData.passwordForm.length < 6 ||
         !(/(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])/.test(this.formData.passwordForm)))) {
        this.alertError.text = "Please, check your password. Missing required characters!";
        this.alertError.visible = true;
        this.needFill = true;
        return null;
      }

      if (!this.areasChecked.length && this.formData.role !== 'manager') {
        this.needFill = true;
        this.alertError.text = 'Working area mandatory';
        this.alertError.visible = true;
        return null;
      }
      this.formData.areas = [];
      for (let i = 0; i < this.areasChecked.length; i++) {
        this.formData.areas.push(this.areasChecked[i].id);
      }
      if (this.formData.areas.length === 0 || this.formData.role === 'manager') {
        this.formData.areas = [];
      }
      if (this.authUser.company) {
        this.formData.company = this.authUser.company.id;
      }
      if (!this.formData.company && this.$route.params.companyId) {
        this.formData.company = this.$route.params.companyId;
      }

      const formData = new FormData();
      this.formData.password = this.formData.passwordForm;
      for (const key in this.formData) {
        formData.append(key, this.formData[key]);
      }
      if (!this.formData.id) {
        return this.$http.post('users/', this.formData,
          {
            method: 'POST',
            headers: {
              // 'Content-Type': 'multipart/form-data',
              // 'Content-Type': 'application/json',
              Authorization: `Token ${this.access_token}`,
            },
            // emulateJSON: true,
          })
          .then((response) => {
            if (response.status !== 201) {
              console.log(response);
              return null;
            }
            return self.sendPicture(self, response.body.id);
            // this.$refs.user_added.show();
            // return response.json();
          })
          .catch((response) => {
            if (response.status === 401) {
              this.onLogout();
            }
            if (response.body.username && response.body.username.length) {
              self.alertError.text = response.body.username[0];
            } else if (response.body.non_field_errors) {
              self.alertError.text = response.body.non_field_errors[0];
            } else {
              self.alertError.text = response.body.detail;
            }
            self.alertError.visible = true;
            this.needFill = false;
          });
      }

      if (!this.formData.passwordForm) {
        delete (this.formData.password);
      }
      return this.$http.patch(`users/${this.formData.id}/`, this.formData,
        {
          method: 'PATCH',
          headers: {
            // 'Content-Type': 'multipart/form-data',
            // 'Content-Type': 'application/json',
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            return null;
          }
          return self.sendPicture(self, response.body.id);
          // this.$refs.user_added.show();
          // return response.json();
        })
        .catch((resp) => {
          if (resp.status === 401) {
            this.onLogout();
          }
          self.alertError.text = resp.body;
          self.alertError.visible = true;
          this.needFill = false;
        });
    },
    sendPicture(self, id) {
      if (!id) {
        return;
      }
      if (!self.formData.pictureBugFixer) {
        self.alertSuccess.visible = true;
        this.needFill = false;
        setTimeout(() => {
          self.returnBack();
        }, 3000);
        return;
      }
      const formDataPicture = new FormData();
      formDataPicture.append('picture', self.formData.pictureBugFixer);
      self.$http.patch(`users/${id}/`, formDataPicture,
        {
          method: 'PATCH',
          headers: {
            // 'Content-Type': 'multipart/form-data',
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            return;
          }
          self.alertSuccess.visible = true;
          this.needFill = false;
          setTimeout(() => {
            self.returnBack();
          }, 3000);
          // self.$refs.user_added.show();
          // return response.json();
        })
        .catch(resp => resp);
    },
    getUrl() {
      return `${process.env.START_URL}/configuration/usersPermissions`;
    },
    returnBack() {      
      window.close();
      //this.$router.push({ name: 'User & Permissions', params: { type: this.type } });
    },
    getUser(id) {
      return this.$http.get(`users/${id}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            return response.status;
          }
          this.userData = response.body;
          return response.status;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    getAreaById(id, area = this.areas) {
      for (let i = 0; i < area.length; i++) {
        if (area[i].id === id) {
          return area[i];
        }
        const res = this.getAreaById(id, area[i].subareas);
        if (res) {
          return res;
        }
      }
      return null;
    },
    fillData() {
      this.formData.id = this.userData.id;
      this.mustDelete = this.mustDelete && this.formData.id !== this.authUser.id;
      this.formData.first_name = this.userData.first_name;
      this.formData.last_name = this.userData.last_name;
      this.formData.username = this.userData.username;
      this.formData.email = this.userData.email;
      this.formData.upn = this.userData.upn;
      this.formData.role = this.userData.role;
      this.formData.is_deleted = this.userData.is_deleted;
      this.formData.open_actions_count = this.userData.open_actions_count;
      this.formData.assigned_actions_count = this.userData.assigned_actions_count;
      if (this.userData.picture) {
        this.formData.img = this.userData.picture;
      }
      this.areasChecked = [];
      for (let i = 0; i < this.userData.areas.length; i++) {
        const area = this.getAreaById(this.userData.areas[i].id);

        if (!area) continue;

        this.areasChecked.push(area);
      }
    },
    getOrientation(file, callback) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const view = new DataView(e.target.result);
        if (view.getUint16(0, false) !== 0xFFD8) return callback(-2);
        const length = view.byteLength;
        let offset = 2;
        while (offset < length) {
          const marker = view.getUint16(offset, false);
          offset += 2;
          if (marker === 0xFFE1) {
            if (view.getUint32(offset += 2, false) !== 0x45786966) return callback(-1);
            const little = view.getUint16(offset += 6, false) === 0x4949;
            offset += view.getUint32(offset + 4, little);
            const tags = view.getUint16(offset, little);
            offset += 2;
            for (let i = 0; i < tags; i++) {
              if (view.getUint16(offset + (i * 12), little) === 0x0112) {
                return callback(view.getUint16(offset + (i * 12) + 8, little));
              }
            }
          } else if ((marker & 0xFF00) !== 0xFF00) break;
          else offset += view.getUint16(offset, false);
        }
        return callback(-1);
      };
      reader.readAsArrayBuffer(file);
    },
    imageOrientation(input, self) {
      self.getOrientation(input.files[0], (orientation) => {
        const img = document.getElementById('icon-frame');
        img.className = 'img-icon ';
        if (orientation === 6 || orientation === 5) {
          img.className += 'rotate90';
        }
        if (orientation === 8 || orientation === 7) {
          img.className += 'rotate270';
        }
        if (orientation === 3 || orientation === 4) {
          img.className += 'rotate180';
        }
        console.log('orientation: ' + orientation);
      });
    },

  },
  computed: {

  },
  created() {
    this.getUsersList();
    this.getWorkingAreas().then(() => {
      if (this.$route.params.userId) {
        this.getUser(this.$route.params.userId)
          .then(() => this.fillData());
      }
    });
    // const authUser = localStorage.getItem('authUser');
    // this.authUser = authUser ? JSON.parse(authUser) : null;
    this.mustDelete = this.authUser && (this.authUser.role == 'manager' || this.authUser.role == 'superuser');
  },
  watch: {
    areas() {
      this.updateSuggestArea();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/addUser/personalDetails/personalDetails.component.js